import React, { useState } from 'react';
import {
  Box, Paper, Tabs, Tab, ToggleButton, ToggleButtonGroup,
  Table, TableHead, TableRow, TableCell, TableBody,
} from '@mui/material';
import { NEW_REGIME_SLABS, OLD_REGIME_SLABS, ASSESSMENT_YEARS, formatINR } from './constants';

function SlabTable({ slabs }) {
  return (
    <Table size="small" sx={{ '& th': { bgcolor: '#f1f5f9', fontWeight: 600 } }}>
      <TableHead>
        <TableRow>
          <TableCell>FROM</TableCell>
          <TableCell>TO</TableCell>
          <TableCell align="right">TAX RATE</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {slabs.map((s, idx) => (
          <TableRow key={idx}>
            <TableCell>{s.to === null ? `Above ${formatINR(s.from - 1)}` : formatINR(s.from)}</TableCell>
            <TableCell>{s.to === null ? '' : `- ${formatINR(s.to)}`}</TableCell>
            <TableCell align="right">{s.rate}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}

export default function TaxSlabsPanel() {
  const [regime, setRegime] = useState('new'); // 'new' | 'old'
  const [ay, setAy] = useState('2027-28');

  const slabs = regime === 'new' ? NEW_REGIME_SLABS : OLD_REGIME_SLABS;

  return (
    <Paper variant="outlined" sx={{ p: 2 }}>
      <Tabs
        value={regime}
        onChange={(_, v) => setRegime(v)}
        sx={{ borderBottom: 1, borderColor: 'divider', mb: 2 }}
      >
        <Tab value="new" label="New Tax Regime" />
        <Tab value="old" label="Old Tax Regime" />
      </Tabs>

      {regime === 'new' && (
        <Box sx={{ mb: 2 }}>
          <ToggleButtonGroup
            exclusive
            size="small"
            value={ay}
            onChange={(_, v) => v && setAy(v)}
          >
            {ASSESSMENT_YEARS.map((opt) => (
              <ToggleButton key={opt.value} value={opt.value} sx={{ borderRadius: '20px !important', px: 2 }}>
                {opt.label}
              </ToggleButton>
            ))}
          </ToggleButtonGroup>
        </Box>
      )}

      <SlabTable slabs={slabs} />
    </Paper>
  );
}
